import React, { useState, useEffect } from "react";
import TextCaptcha from "../components/TextCaptcha";
import "../cssfiles/loginpage.css";
import "../cssfiles/homepage.css"
import Loginpageleftimage from "./Loginpageleftimage";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  IconButton,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  Input,
} from "@mui/material";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import brandlogo from "../images/LKLogo.png";
import googleimg from "../images/Google.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useDispatch } from "react-redux";
import { updatelogindetails, updateusername, updateuserdeatils, updateorganizationdata, updateprojectdata, updateplatjson, updateuserinactivitytimeout } from "../store/login_data";
import { loginverify, ciamloginverify,verifyOtp, resendOtp} from "../Restclient/datacollection";
import { updatetheme } from "../store/theme_data";
import { useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import LK_Loading from "../images/LK_Loading.gif"
import { setPage } from "../store/pageselect_data";
import CustomDialogBoxPasswordWarning from "./CommonComponents/CustomDialogBoxPasswordWarning";

export default function Loginpage() {
  const { loginWithRedirect, getAccessTokenSilently, isAuthenticated, user, isLoading} = useAuth0();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [emailValid, setEmailValid] = useState(false);
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [passwordValid, setPasswordValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [errormsgflag, setErrormsgflag]= useState(false);
  const username = useSelector((state) => state.logindata.username);
  const [loading,setLoading]=useState(false);
  const [otp, setOtp] = useState(""); // State for OTP input
  const [otpRequired, setOtpRequired] = useState(false); // State to toggle OTP input visibility
  // const [isLockedOut, setIsLockedOut] = useState(false);
  const [otpTimer, setOtpTimer] = useState(60);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [showPasswordWarning, setShowPasswordWarning] = useState(false);
  const [passwordExpiryInfo, setPasswordExpiryInfo] = useState({ days: 0, hours: 0 });
  const [passwordExpired, setPasswordExpired] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  // CAPTCHA logic
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);


const restcallback = (res) => {
  
  // Handle 429 lockout error
  if (res.status === 429 ) {
    setErrorMsg("Too many login attempts, please try again later.");
    setErrormsgflag(true);
    setLoading(false);
    setShowCaptcha(false);
    setCaptchaVerified(false);
    setLoginAttempts(0);
    return;
  }
 if (res.status === 401) {
    setErrorMsg(res?.error?.message || "Invalid Credentials.");
    setErrormsgflag(true);
    setLoading(false);
    setLoginAttempts(prev => {
      const next = prev + 1;
      if (next >= 3) {
        setShowCaptcha(true);
        setCaptchaVerified(false);
      }
      return next;
    });
    return;
  }
  else if (res.error) {
    if(typeof res.error === "string"){
      setErrorMsg(res.error);
    }else{
      setErrorMsg("Invalid Credentials.");
    }
    setErrormsgflag(true);
    setLoading(false);
    setLoginAttempts(prev => {
      const next = prev + 1;
      if (next >= 3) {
        setShowCaptcha(true);
        setCaptchaVerified(false);
      }
      return next;
    });
    return;
  } else if (res.data?.data?.requirePasswordChangeOnFirstLogin) {
    // First login - password change required
    
    sessionStorage.setItem("userEmail", res.data.data.email || email);
    sessionStorage.setItem("isFirstLogin", "true");
    setLoading(false);
    navigate("/changepassword");
    return;
  } else if (res?.data && res?.data?.data && res.data?.data?.passwordExpired && res.data?.data?.tempToken) {
      // Password expired - store temp token and show dialog
      
      sessionStorage.setItem("tempPasswordChangeToken", res.data.data.tempToken);
      sessionStorage.setItem("userEmail", email);
      setPasswordExpired(true);
      setLoading(false);
      return;
  } else if (res.data?.data?.status) {
      if (res.data.data.otpRequired) {
         // Check for password warning - show immediately before OTP
        if (res.data.data.passwordWarning && res.data.data.daysUntilExpiry) {
          
          const seconds = res.data.data.daysUntilExpiry;
          const days = Math.floor(seconds / 86400);
          const hours = Math.floor((seconds % 86400) / 3600);
          setPasswordExpiryInfo({ days, hours });
          sessionStorage.setItem("userEmail", email);
          setShowPasswordWarning(true);
          setLoading(false); // CRITICAL: Stop loading spinner so dialog can show
          return; // Stop here, show dialog
        }
        
        // Normal OTP flow (no password warning)
        setErrorMsg(res.data.data.message || "OTP verification required.");
        setOtpRequired(true);
        setLoading(false);
      }
  } else {
    setErrorMsg("Login failed. Please try again.");
    setErrormsgflag(true);
    setLoading(false);
    setLoginAttempts(prev => {
      const next = prev + 1;
      if (next >= 3) setShowCaptcha(true);
      return next;
    });
  }
};


const handleKeyDown = (event) => {
 if (event.key === "Enter") {
  if(event.target.id === "otp") {
    handleOtpSubmit();
  }  
  else{
    handleSubmit();
  }  
 }
};

const restcallbackOtp = (res) => {
  if (res.error) {
    setErrorMsg("Invalid OTP.");
    setErrormsgflag(true);
    setLoading(false);
  }else if (res.status === 401) {
    // Explicitly handle invalid credentials
    setErrorMsg("Invalid OTP.");
    setErrormsgflag(true);
    setLoading(false);
  } 
  else if (res.data.data.status) {
      dispatch(
          updatelogindetails({
              userauthstate: 1,
              userpermissions: 1,
          })
      );
      
      dispatch(updateusername(res.data.data.username));
      dispatch(updateuserdeatils(res.data.data.userdetails))
      dispatch(updateorganizationdata(res.data.data.Organization))
      dispatch(updateprojectdata(res.data.data.project))
      dispatch(updateplatjson(res.data.data.plantview))

      let userdetails = res.data.data.userdetails;

      
      const inactivityTimeout = (res.data && res.data.data && res.data.data.loginpolicy) ? res.data.data.loginpolicy: 1000000;
      sessionStorage.setItem("inactivityTimeout", inactivityTimeout);
      dispatch(updateuserinactivitytimeout(inactivityTimeout))

      // Note: Password warning is now handled before OTP in restcallback()
      // No need to check sessionStorage here anymore


    const adminPermissions = ['SUCR01', 'SUAS02', 'OGCR03', 'SBCR04', 'PJCR05', 'USCR06', 'USPC07', 'LGPC08', 'RLAC09'];
    const hasAdminPermission = userdetails.User_Role_Details.Permissions?.some(permission => 
        adminPermissions.includes(permission)
    );
    if (hasAdminPermission) {
          dispatch(setPage("usermanage"));
      } 
     
      // var projectlist = []
      // if(res.data.data.userdetails.Organizationid != "All") { //Case for Org Level Users
      

      sessionStorage.setItem("Token",res.data.data.Token);
      setLoading(false)
      navigate("/home");
    } else {
      if((res.data.data.message != undefined) && (res.data.data.message != null)){
          if(res.data.data.message == "Password Expired"){
            setErrorMsg("Your password has expired")
          }else if(res.data.data.message == "User Account is Disabled"){
            setErrorMsg("Your User Account is Disabled")
          }else{
            setErrorMsg(res.data.data.message)
          }

      }
      else{
        setErrorMsg("You have entered an invalid username or password")
        
      }
      setErrormsgflag(true);

      dispatch(
        updatelogindetails({
          userauthstate: 0,
          userpermissions: 0,
        })
      );
      setLoading(false)
      setErrormsgflag(true)
    }
  
};

const restCIAMCallback = (res) => {

  if (res.data.data.status) {
    dispatch(
      updatelogindetails({
        userauthstate: 1,
        userpermissions: 1,
      })
    );

    dispatch(updateusername(res.data.data.username));
    dispatch(updateuserdeatils(res.data.data.userdetails))
    dispatch(updateorganizationdata(res.data.data.Organization))
    dispatch(updateprojectdata(res.data.data.project))
    dispatch(updateplatjson(res.data.data.plantview))

    let userdetails = res.data.data.userdetails;

    const inactivityTimeout = (res.data && res.data.data && res.data.data.loginpolicy && res.data.data.loginpolicy.Login_Inactivity_Timeout) ? res.data.data.loginpolicy.Login_Inactivity_Timeout : 1000000;
    
    dispatch(updateuserinactivitytimeout(inactivityTimeout))


    const adminPermissions = ['SUCR01', 'SUAS02', 'OGCR03', 'SBCR04', 'PJCR05', 'USCR06', 'USPC07', 'LGPC08', 'RLAC09'];
    const hasAdminPermission = userdetails.User_Role_Details.Permissions?.some(permission => 
        adminPermissions.includes(permission)
    );
    if (hasAdminPermission) {
        dispatch(setPage("usermanage"));
    } 

    //var projectlist = []
    // if(res.data.data.userdetails.Organizationid != "All") {

    //   if(res.data.data.userdetails.Projectid === "All") {
    //     projectlist.push({
    //       ProjectId: "All",
    //       Projectname: "Organization",
    //       Projectdetails: {
    //         Country:  res.data.data.Organization.Oranizationdetails.Country,
    //         Latitude:  res.data.data.Organization.Oranizationdetails.Latitude,
    //         Location: res.data.data.Organization.Oranizationdetails.Location,
    //         Longitude:  res.data.data.Organization.Oranizationdetails.Longitude,
    //         Pin: res.data.data.Organization.Oranizationdetails.Pin,
    //         Region: "",
    //         State: res.data.data.Organization.Oranizationdetails.State
    //       },
    //       Logo: ""
    //     })
    //     for(let i=0; i<res.data.data.project.length; i++) {
    //       projectlist.push(res.data.data.project[i])
    //     }
    //   } else {
    //     projectlist = res.data.data.project
    //   }
    // }
    // dispatch(updateusername(res.data.data.username));
    // dispatch(updateuserdeatils(res.data.data.userdetails))
    // dispatch(updateorganizationdata(res.data.data.Organization))
    // dispatch(updateprojectdata(projectlist))
    // dispatch(updateplatjson(res.data.data.plantview))
    //Encrypt this token and store it in session storage
    //Check for tab wise storageof tokens.
    sessionStorage.setItem("Token",res.data.data.Token);
    setLoading(false)
    navigate("/home");
  } else {
    dispatch(
      updatelogindetails({
        userauthstate: 0,
        userpermissions: 0,
      })
    );
    setErrormsgflag(true)
  }
};

const resendCallback = (res) => {

}

// const handlekeypress = (event) => {
//   if(event.key === "Enter") {
//     setLoading(true);
//     // loginverify(email, password, rememberMe);
//     loginverify(email, password, rememberMe, restcallback);
//   }
// };
const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const handleEmailChange = (e) => {
  if (e.target.value.length <= 60) {
    setEmail(e.target.value);
  }
}

const validatePassword = (password) => {
  //const isValid= password.length >=8 && password.length<=30;
  const isValid = password.length >= 12 && password.length <= 64;
  setPasswordValid(isValid);
  return isValid;
};  

const togglePasswordVisibility = () => {
  setShowPassword(!showPassword);
};

const handleCaptchaSuccess = () => {
  setShowCaptcha(false);
  setCaptchaVerified(true);
  setLoginAttempts(0); // Reset attempts after successful CAPTCHA
  setErrorMsg("");
  setErrormsgflag(false);
};

// Handle CAPTCHA lockout error from server
const handleCaptchaLockout = (msg) => {
  setShowCaptcha(false);
  setCaptchaVerified(false);
  setErrorMsg(msg);
  setErrormsgflag(true);
};


const handleSubmit = () => {

  if (!email) {
    setErrorMsg("Email is required");
    setErrormsgflag(true);
    return;
  }

  if (!validateEmail(email)) {
    setErrorMsg("Please enter a valid email");
    setErrormsgflag(true);
    return;
  }

  if (!password) {
    setErrorMsg("Password is required");
    setErrormsgflag(true);
    return;
  }

  if (!consentChecked) {
    setErrorMsg("Please accept the Privacy Notice and Data Privacy Policy to continue.");
    setErrormsgflag(true);
    return;
  }

  // if (!validatePassword(password)) {
  //   setErrorMsg(
  //     "Password must be 8-20 characters with uppercase, lowercase, number and special character"
  //   );
  //   setErrormsgflag(true);
  //   return;
  // }

  loginverify(email, password, rememberMe, restcallback);
};

  const handleOtpSubmit = () => {
        if (!otp) {
          setErrorMsg("Enter the OTP");
          setErrormsgflag(true);
          return;
        }
        const emailID = email; // Assuming email is used as userId for OTP verification
    
        setErrormsgflag(false);
        setLoading(true);
    
        // Verify OTP (replace with your OTP verification logic)
        verifyOtp(otp,emailID ,restcallbackOtp)

  };


useEffect(() => {
  const remember = localStorage.getItem("rememberMe");
  if (remember === "true") {
    const storedEmail = localStorage.getItem("email");
    const storedPassword = localStorage.getItem("password");
    setEmail(storedEmail || "");
    setPassword(storedPassword || "");
    setRememberMe(true);
  }
}, []);

useEffect(() => {
  // Show loading if Auth0 is still processing
  // if (isLoading) {
  //   setLoading(true);
  //   return ;
  // }
  if (isAuthenticated) {
    
    getAccessTokenSilently()
      .then((token) => {
        setLoading(true);
        ciamloginverify(token, restCIAMCallback)
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching token:", error);
      });
  }
}, [isAuthenticated, getAccessTokenSilently, user]);


useEffect(() => {
  let timer;
  if (otpRequired && otpTimer > 0) {
    setCanResendOtp(false);
    timer = setInterval(() => {
      setOtpTimer((prev) => prev - 1);
    }, 1000);
  } else if (otpRequired && otpTimer === 0) {
    setCanResendOtp(true);
  }
  return () => clearInterval(timer);
}, [otpRequired, otpTimer]);

useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const hasAuthCode = urlParams.has('code');
    const hasAuthState = urlParams.has('state');
    
    // If we have Auth0 redirect parameters, show loading immediately
    if (hasAuthCode && hasAuthState) {
      
      setLoading(true);
    }
  }, []);

const handleResendOtp = () => {
  // Your resend OTP logic here, e.g.:
  resendOtp( email,resendCallback)
  setOtpTimer(60);
  setCanResendOtp(false);
};

const handleCIAMSubmit = async () => {
  if (!consentChecked) {
    setErrorMsg("Please accept the Privacy Notice and Data Privacy Policy to continue.");
    setErrormsgflag(true);
    return;
  }
  setLoading(true);
  try {
    await loginWithRedirect({
      authorizationParams: {
        prompt: "login", // Forces the login page to appear
      },
    });
  } catch (error) {
    console.error("Error during login:", error);
    setErrorMsg("Login failed. Please try again.");
    setErrormsgflag(true);
  }
};

  return (
    <div className="container">
      <>
      <div className="left-side">
        <Loginpageleftimage />
      </div>
      <div className="right-side">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flexGrow: 1 }}></div>
          <div className="formcompanylogo">
            <img
              src={brandlogo}
              alt="placeholder"
              style={{ marginLeft: "17px", height: "55px", width: "150px" }}
            />
          </div>
        </div>
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "50px" }}
          >
            <div style={{ flexGrow: 1 }}></div>
            <div className="loginarea">
              <div className="loginSignup">
                <Typography
                  className="signintext"
                  style={{
                    fontSize: "30px",
                    fontWeight: 700,
                    marginRight: "135px",
                  }}
                >
                  Sign in
                </Typography>
                <span style={{ fontSize: "16px", marginLeft: "-42px" }}></span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  marginTop: "25px",
                  marginBottom: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    textAlign: "start",
                    marginBottom: "10px",
                    fontSize: "18px",
                    fontWeight: "400",
                    color: "#3C3C3C"
                  }}
                >
                  <label htmlFor="username">
                    Email ID
                    <span
                      className="mandatory"
                      style={{ color: "red", marginLeft: "5px" }}
                    >
                      *
                    </span>
                  </label>
                </div>
                <div>
                  <FormControl
                    sx={{ m: 1, width: "358px", marginLeft: "2px" }}
                    variant="standard"
                  >
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      required
                      onChange={handleEmailChange}
                      onKeyDown={handleKeyDown}
                    />
                  </FormControl>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                  <div
                    style={{
                      display: "flex",
                      textAlign: "start",
                      marginBottom: "10px",
                      fontSize: "18px",
                      fontWeight: "400",
                      color: "#3C3C3C"
                    }}
                  >
                    <label htmlFor="password">
                      Password
                      <span
                        className="mandatory"
                        style={{ color: "red", marginLeft: "5px" }}
                      >
                        *
                      </span>
                    </label>
                  </div>
                <div>
                  <FormControl
                    sx={{ m: 1, width: "358px", marginLeft: "2px" }}
                    variant="standard"
                  >
                    <Input
                      id="standard-adornment-password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                    /*  minLength="8"
                      maxLength="30" */
                      onChange={(e) => {
                                /*if (e.target.value.length <= 30) {*/
                                  setPassword(e.target.value);
                               /* }
                                setErrormsgflag(false);
                              */
                            }
                        } 
                      onKeyDown={handleKeyDown}
                      // label="Password"
                      error={false}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={togglePasswordVisibility}
                            //onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? (
                              <VisibilityOutlinedIcon />
                            ) : (
                              <VisibilityOffOutlinedIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
              </div>
              {otpRequired && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginTop: "20px",
                  }}
                >
                  <Typography style={{ fontSize: "16px", color: "#3C3C3C", marginBottom: "10px" }}>
                    {errorMsg}
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      textAlign: "start",
                      marginBottom: "10px",
                      fontSize: "18px",
                      fontWeight: "400",
                      color: "#3C3C3C",
                    }}
                  >
                    <label htmlFor="otp">
                      OTP
                      <span
                        className="mandatory"
                        style={{ color: "red", marginLeft: "5px" }}
                      >
                        *
                      </span>
                    </label>
                  </div>
                  <div>
                    <FormControl
                      sx={{ m: 1, width: "358px", marginLeft: "2px" }}
                      variant="standard"
                    >
                      <Input
                        id="otp"
                        type="tel"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))} // Allow only digits
                        onKeyDown={handleKeyDown}
                      />

                    </FormControl>
                    {errormsgflag && errorMsg && (
                      <Typography
                        style={{
                          color: "#DC272D",
                          fontSize: "14px",
                          fontWeight: 400,
                          marginLeft: "18px",
                          marginTop: "6px",
                        }}
                      >
                        *{errorMsg}
                      </Typography>
                    )}

                    <div style={{ marginLeft: "16px", display: "flex", alignItems: "center" }}>
                      <Button
                        variant="text"
                        onClick={handleResendOtp}
                        disabled={!canResendOtp}
                        sx={{
                          color: canResendOtp ? "#005C8E" : "#7E7E7E",
                          fontWeight: 600,
                          fontSize: "14px",
                          textTransform: "none",
                          minWidth: "unset",
                          padding: "0 8px",
                        }}
                      >
                        Resend OTP
                      </Button>
                      {!canResendOtp && (
                        <span style={{ marginLeft: "8px", color: "#7E7E7E", fontSize: "14px" }}>
                          00:{otpTimer.toString().padStart(2, "0")}
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={{ marginTop: "20px", width: "250px" }}>
                    <button
                      onClick={handleOtpSubmit}
                      
                      style={{
                        width: "100%",
                        height: "35px",
                        fontSize: "18px",
                        backgroundColor: "#005C8E",
                        color: "#FFFFFF",
                        cursor: "pointer",
                        border: "none",
                        borderRadius: "25px",
                      }}
                    >
                      Verify OTP
                    </button>
                  </div>
                </div>
                )}
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                          color="primary"
                          size="small"
                          sx={{
                              color: "#008CD7",
                              "&.Mui-checked": {
                                color: "#008CD7",
                              },
                            }}
                          />

                      }
                      label={
                        <Typography style={{ fontSize: "14px", color: "#3C3C3C" }}>
                          Remember me
                        </Typography>
                      }
                    />
                  </div>
                  <div>
                    <Link
  to="/forgetPassword"
  state={{ email }}
  className="newOption"
  style={{ fontSize: "16px", marginLeft: "100px", color: '#008CD7' }}
>
  Forgot Password?
</Link>

                  </div>
                </div>
              </div>
              {/* Privacy & Data Consent */}
              {!otpRequired && (
                <div style={{ display: "flex", alignItems: "flex-start", marginTop: "14px", width: "370px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={consentChecked}
                        onChange={(e) => {
                          setConsentChecked(e.target.checked);
                          if (e.target.checked) {
                            setErrormsgflag(false);
                            setErrorMsg("");
                          }
                        }}
                        size="small"
                        sx={{
                          color: consentChecked ? "#008CD7" : "#DC272D",
                          "&.Mui-checked": { color: "#008CD7" },
                          paddingTop: "2px",
                        }}
                      />
                    }
                    label={
                      <Typography style={{ fontSize: "13px", color: "#3C3C3C", lineHeight: "1.5" }}>
                        I have read and agree to the{" "}
                        <Link
                          to="/privacy-notice"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#008CD7", textDecoration: "underline" }}
                        >
                          Privacy Notice
                        </Link>{" "}
                        and{" "}
                        <a
                          href="https://www.lk-ea.com/about/who-we-are/legal/privacy-policy"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#008CD7", textDecoration: "underline" }}
                        >
                          Data Privacy Policy
                        </a>
                        <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                      </Typography>
                    }
                    style={{ alignItems: "flex-start", margin: 0 }}
                  />
                </div>
              )}
              {/* {showCaptcha && !captchaVerified && (
                <div style={{ marginTop: "20px", width: "100%", textAlign: "left" }}>
                  <TextCaptcha onSuccess={handleCaptchaSuccess} onLockout={handleCaptchaLockout} />
                </div>
              )} */}
              {/* !showCaptcha && */}
              {!otpRequired && (
                <>
                  <div style={{ display: "flex", gap: "10px", width: "50%", marginTop: "10px" }}>
                    {loading ? (
                      <img src={LK_Loading} alt="loading..." style={{height:"15%" ,width:"100%",alignSelf:"center"}} />
                    ) : (
                      <>
                        <button
                          onClick={handleSubmit}
                          onKeyDown={handleKeyDown}
                          style={{
                            width: "50%",
                            height: "35px",
                            fontSize: "18px",
                            backgroundColor: "#005C8E",
                            color: "#FFFFFF",
                            cursor: "pointer",
                            border: "none",
                            borderRadius: "25px",
                          }}
                        >
                          Sign In
                        </button>
                        <button
                          onClick={() => handleCIAMSubmit()}
                          style={{
                            width: "50%",
                            height: "35px",
                            fontSize: "18px",
                            backgroundColor: "#005C8E",
                            color: "#FFFFFF",
                            cursor: "pointer",
                            border: "none",
                            borderRadius: "25px",
                          }}
                        >
                          CIAM
                        </button>
                      </>
                    )}
                  </div>
                  {/* Error message below buttons */}
                  {/* !showCaptcha && */}
                  { errormsgflag && (
                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px', width: '80%' }}>
                      <Typography style={{ color: '#DC272D', fontSize: "16px", fontWeight: 400 }}>
                        *{errorMsg}
                      </Typography>
                    </div>
                  )}
                </>
              )}
              {/*<div style={{ marginTop: "12px", textAlign: "left" }}> 
                <span style={{ color: "#7E7E7E", fontFamily: 'Roboto', fontSize: '18px', fontWeight: 400 }}>or Continue with</span> 
                <br />
                <img
                  src={googleimg}
                  alt="Google Logo"
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    marginRight: "330px",
                    marginTop: "10px",
                    border: "2px solid #BCBEB0",
                    cursor: "pointer",
                    padding: "5px",
                  }}
                  onClick={() => handleCIAMSubmit()}
                />
              </div>*/}
              <div className="privacy-text" style={{ marginTop: "10px"}}>
                                     <Typography variant="body2" style={{
                  color: "#7E7E7E",
                  position: "absolute",
                  bottom: 27,
                  fontSize: "15px",
                  textAlign: 'left',
                }}>
                                        By using our application, you agree to the collection and
                                        <br></br> use of information your as outlined in this{" "}
                                        <a
                                      href="https://www.lk-ea.com/about/who-we-are/legal/privacy-policy"
      className="newOption"
      target="_blank"
      rel="noopener noreferrer"
    >Privacy Policy
    </a>
                                         {/* . Thank you for trusting us with your data. */}
                                   </Typography>
                                 </div>
              <div
                style={{
                  color: "#7E7E7E",
                  position: "absolute",
                  bottom: 5,
                  fontSize: "13px",
                  textAlign: "center",
                }}
              >
                The content of this website is copyrighted. All rights reserved
              </div>
            </div>
          </div>
        
      </div>
      </>

      
      {/* Password Expiration Warning Dialog */}
      <CustomDialogBoxPasswordWarning
        openDialog={showPasswordWarning}
        dialogTitle="Password Expiration Warning"
        dialogText={`Your password will expire in ${passwordExpiryInfo.days} day${passwordExpiryInfo.days !== 1 ? 's' : ''} and ${passwordExpiryInfo.hours} hour${passwordExpiryInfo.hours !== 1 ? 's' : ''}. Please change your password to avoid login issues.`}
        handleCloseDialog={() => {
          
          setShowPasswordWarning(false);
          // NOW set otpRequired to show OTP input
          setOtpRequired(true);
          setErrorMsg("OTP sent to your email. Please verify to complete login.");
          setLoading(false);
        }}
        handleConfirmDialog={() => {
          
          setShowPasswordWarning(false);
          // User chose "Change Password Now" - redirect to change password page
          navigate("/changepassword");
        }}
        confirmText="Change Password Now"
        cancelText="Remind Me Later"
        type="Warning"
      />

      {/* Password Expired Dialog */}
      <CustomDialogBoxPasswordWarning
        openDialog={passwordExpired}
        dialogTitle="Password Expired"
        dialogText="Your password has expired. You must change it to continue using the application."
        handleConfirmDialog={() => {
          
          setPasswordExpired(false);
          navigate("/changepassword");
        }}
        confirmText="Change Password Now"
        type="Error"
      />
    </div>
  );
};